import { get, has, isObject, size, transform } from "lodash-es"

export const flattenID = (obj: any, identifier = "id") =>
  transform(obj, (accumulator, value, key) => {
    let val = value
    if (has(value, identifier) && size(value) === 1)
      val = parseInt(get(value, identifier))
    else if (isObject(value)) val = flattenID(value, identifier)
    accumulator[key] = val
  }) as any

export const removeTypename = (value: any) => {
  if (value === null || value === undefined) {
    return value
  } else if (Array.isArray(value)) {
    return value.map(v => removeTypename(v))
  } else if (typeof value === "object") {
    const newObj = {}
    Object.entries(value).forEach(([key, v]) => {
      if (key !== "__typename") {
        newObj[key] = removeTypename(v)
      }
    })
    return newObj
  }
  return value
}
